import { useEffect, useState } from 'react';
import { Box, Text, Flex, Card, Avatar, Badge, SegmentedControl } from '@radix-ui/themes';
import CircleProgress from '../../shared/CircleProgress';
import LoadingIndicator from '../../shared/LoadingIndicator';
import { reportService } from '../../../services/teacher/reportService';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import UserAvatar from '../../common/UserAvatar';

const StudentReport = ({ student_id }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [reportData, setReportData] = useState([]);
    const [student, setStudent] = useState(null);
    const [selectedReportView, setSelectedReportView] = useState('first_attempt');

    console.log('in student report student_id>>>>>', student_id);
    useEffect(() => {
        const fetchReport = async () => {
            try {
                setLoading(true);
                const data = await reportService.getStudentReport(student_id);
                console.log('data>>>>>', data);
                setStudent(data.student_details);
                setReportData(data.student_report);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchReport();
    }, [student_id]);

    const calculateSummary = (data) => {
        let totalQuizzes = 0;
        let totalAttempts = 0;
        let totalScore = 0;
        let totalPossibleScore = 0;
        let minScore = 0;
        let maxScore = 0;


        data.forEach(course => {
            course.teaching_plans.forEach(plan => {
                if (plan.quizzes) {
                    totalQuizzes += plan.quizzes.length;
                    plan.quizzes.forEach(quiz => {
                        quiz.quiz_attempts.forEach(attempt => {
                            totalAttempts++;
                            totalScore += attempt.score;
                            totalPossibleScore += attempt.total_score;
                            if (attempt.score < minScore) {
                                minScore = attempt.score;
                            }
                            if (attempt.score > maxScore) {
                                maxScore = attempt.score;
                            }
                        });
                    });
                }

            });
        });

        const averageScore = totalPossibleScore > 0
            ? Math.round((totalScore / totalPossibleScore) * 100)
            : 0;

        return {
            totalQuizzes,
            totalAttempts,
            averageScore,
            minScore,
            maxScore
        };
    };

    // if(student?.payment_details.status != 'active'){
    //     return (
    //         <Box>
    //             <Text>Please activate your subscription to view this report</Text>
    //         </Box>
    //     );
    // }


    const createChartData = (quizzes) => {
        const data = [];
        let quizNumber = 1;

        quizzes.forEach(quiz => {
            if (quiz.quiz_attempts && quiz.quiz_attempts.length > 0) {
                // Get the first attempt
                const attempt = selectedReportView === 'first_attempt' ? quiz.quiz_attempts[0] : quiz.quiz_attempts[quiz.quiz_attempts.length - 1];
                const score = attempt.percentage;

                data.push({
                    quizNumber: `Q${quizNumber}`,
                    score: score
                });
            } else {
                data.push({
                    quizNumber: `Q${quizNumber}`,
                    score: 0
                });
            }
            quizNumber++;
        });

        return data;
    };




    if (loading) {
        return (
            <Flex align="center" justify="center" p="4">
                <LoadingIndicator />
            </Flex>
        );
    }

    if (error) {
        return (
            <Flex align="center" justify="center" p="4">
                <Text color="red">Error: {error}</Text>
            </Flex>
        );
    }

    return (
        <Box p="4">
            <Flex direction="column" align="center" gap="3" mb="4">
                <UserAvatar
                    size="8"
                    user={{profile_picture:student?.profile_picture, firstname:student?.firstname, lastname:student?.lastname}}
                    radius="full"
                />
                <Text size="2" weight="medium">
                    {student?.firstname} {student?.lastname}
                </Text>

                <Flex direction="row" gap="0" justify="center">
                    <Flex direction="column" gap="1" p="2" align="end" style={{ borderRight: '1px solid #e0e0e0' }}>
                        <Box>
                            <Text size="1" color="gray">Total Quizzes</Text>
                            <Badge color="gray" size="1" weight="bold">
                                {calculateSummary(reportData).totalQuizzes}
                            </Badge>
                        </Box>

                        <Box>
                            <Text size="1" color="gray">Total Attempts</Text>
                            <Badge color="gray" size="1" weight="bold">
                                {calculateSummary(reportData).totalAttempts}
                            </Badge>
                        </Box>

                    </Flex>
                    <Flex direction="column" gap="1" justify="start" align="start" p="2">
                        <Box>
                            <Badge color="gray" size="1" weight="bold">
                                {calculateSummary(reportData).averageScore}%
                            </Badge>
                            <Text size="1" color="gray">Average Score</Text>
                        </Box>

                        <Box>
                            <Badge color="gray" size="1" weight="bold">
                                {calculateSummary(reportData).minScore}
                            </Badge>
                            <Text size="1" color="gray">Min Score</Text>
                        </Box>
                    </Flex>
                </Flex>
            </Flex>
            <Flex direction="row" justify="center" align="center" gap="2" mt="2" mb="2">
                <SegmentedControl.Root defaultValue="first_attempt" radius="full" onValueChange={(value) => setSelectedReportView(value)}>
                    <SegmentedControl.Item value="first_attempt">First Attempt</SegmentedControl.Item>
                    <SegmentedControl.Item value="last_attempt">Last Attempt</SegmentedControl.Item>
                </SegmentedControl.Root>
            </Flex>


            <Flex direction="column" gap="4">
                {reportData.map((course) => (
                    <Box key={course.id} style={{ minWidth: '300px', width: '100%' }}>
                        <Box>
                            <Text weight="bold">{course.level.label} | {course.subject.name}</Text>

                            {course.teaching_plans.map((plan) => (
                                <Box key={plan.id} mt="3">
                                    <Flex direction="column" align="center" gap="0">
                                        {/* <CircleProgress
                                            progress={plan.progress_percentage}
                                            label={`${plan.progress_percentage}%`}
                                            size={48}
                                        /> */}
                                        {/* <Text weight="bold">Teaching Plan {plan.id}</Text> */}
                                        <Text size="1">Lessons {plan.start_lesson_id}-{plan.end_lesson_id}</Text>
                                        {plan.quizzes?.length > 1 && (
                                            <Box style={{ width: '100%', height: '300px' }}>
                                                <ResponsiveContainer width="100%" height="100%">
                                                    <LineChart
                                                        data={createChartData(plan.quizzes)}
                                                        margin={{
                                                            top: 10,
                                                            right: 10,
                                                            left: 10,
                                                            bottom: 10,
                                                        }}
                                                    >
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis
                                                            dataKey="quizNumber"
                                                            style={{ fontSize: '12px' }}
                                                            height={20}
                                                        />
                                                        <YAxis
                                                            domain={[0, 100]}
                                                            style={{ fontSize: '12px' }}
                                                            width={30}
                                                            tickCount={6}
                                                        />
                                                        <Tooltip
                                                            contentStyle={{ fontSize: '12px' }}
                                                        />
                                                        <Legend
                                                            wrapperStyle={{ fontSize: '12px' }}
                                                            height={20}
                                                        />
                                                        <Line
                                                            type="monotone"
                                                            dataKey="score"
                                                            stroke="#8884d8"
                                                            name="Score %"
                                                        />
                                                    </LineChart>
                                                </ResponsiveContainer>
                                            </Box>
                                        )}
                                    </Flex>

                                    {plan.quizzes?.length > 0 && (
                                        <Box mt="3">
                                            {/* <Text size="1" weight="bold">Quizzes</Text> */}
                                            {plan.quizzes.map((quiz, index) => {
                                                const attempt = selectedReportView === 'first_attempt' ? quiz.quiz_attempts?.[0] : quiz.quiz_attempts?.[quiz.quiz_attempts.length - 1];
                                                if (!attempt) {
                                                    return <Box p="2" key={quiz.id}>
                                                        <Text size="1" weight="bold" as='p'>Quiz #{index + 1} | {new Date(quiz.created_at).toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}</Text>
                                                        <Text color="gray" size="1" weight="bold" as='p'>No attempt found</Text>
                                                    </Box>
                                                } else {
                                                    return (
                                                        <Box p="2" key={quiz.id}>
                                                            <Text size="1" weight="bold" as='p'>Quiz #{index + 1} | {new Date(quiz.created_at).toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}</Text>
                                                            {quiz.quiz_attempts.length > 0 && (
                                                                <Flex direction="row" align="center" justify="start" key={quiz.quiz_attempts.id} mt="2" gap="2">
                                                                    <CircleProgress
                                                                        progress={attempt?.percentage}
                                                                        label={`${attempt?.percentage}%`}
                                                                        size={60}
                                                                        color={'#00b341'}
                                                                    />
                                                                    <Box minWidth="60%">
                                                                        {/* <Text size="2" weight="bold">
                                                                        {quiz.quiz_attempts[selectedReportView === 'first_attempt' ? 0 : quiz.quiz_attempts.length - 1].first_attempt ? 'First Attempt' : 'Retry'}
                                                                    </Text> */}
                                                                        <Flex direction="row" gap="2" align="center" justify="between" mb="1">
                                                                            <Text size="1">Score</Text>
                                                                            <Badge>
                                                                                {attempt.score}/{attempt.total_score}
                                                                            </Badge>
                                                                        </Flex>
                                                                        <Flex direction="row" gap="2" align="center" justify="between" mb="1">
                                                                            <Text size="1">Vocabulary Score</Text>
                                                                            <Badge>
                                                                                {attempt?.vocabulary_score}
                                                                            </Badge>
                                                                        </Flex>
                                                                        <Flex direction="row" gap="2" align="center" justify="between" mb="1">
                                                                            <Text size="1">Concept Score</Text>
                                                                            <Badge>
                                                                                {attempt?.concept_score}
                                                                            </Badge>
                                                                        </Flex>
                                                                        <Flex direction="row" gap="2" align="center" justify="between" mb="1">
                                                                            <Text size="1">Application Score</Text>
                                                                            <Badge>
                                                                                {attempt?.application_score}
                                                                            </Badge>
                                                                        </Flex>
                                                                    </Box>
                                                                </Flex>
                                                            )}
                                                        </Box>
                                                    );
                                                }
                                            })}
                                        </Box>
                                    )}
                                </Box>
                            ))}

                            {course.teaching_plans.length === 0 && (
                                <Text color="gray" mt="2">No teaching plans available</Text>
                            )}
                        </Box>
                    </Box>
                ))}
            </Flex>
        </Box>

    );
};

export default StudentReport;
